import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Textarea } from '@/components/ui/textarea';

import { ESTADOS_CIVIS, type ClienteFormData } from './clienteFormUtils';

interface StepComplementarProps {
  form: ClienteFormData;
  set: (field: keyof ClienteFormData, value: string) => void;
  isPF: boolean;
}

export function StepComplementar({ form, set, isPF }: StepComplementarProps) {
  return (
    <div className="space-y-4">
      {/* Campos complementares — apenas PF */}
      {isPF && (
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5">
            <Label htmlFor="profissao">Profissão</Label>
            <Input
              id="profissao"
              autoFocus
              value={form.profissao}
              onChange={(e) => set('profissao', e.target.value)}
              placeholder="Profissão"
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="estado_civil">Estado Civil</Label>
            <Select value={form.estado_civil} onValueChange={(v) => set('estado_civil', v)}>
              <SelectTrigger id="estado_civil">
                <SelectValue placeholder="Selecione" />
              </SelectTrigger>
              <SelectContent>
                {ESTADOS_CIVIS.map(({ value, label }) => (
                  <SelectItem key={value} value={value}>{label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="data_nascimento">Data de Nascimento</Label>
            <Input
              id="data_nascimento"
              type="date"
              value={form.data_nascimento}
              onChange={(e) => set('data_nascimento', e.target.value)}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="nacionalidade">Nacionalidade</Label>
            <Input
              id="nacionalidade"
              value={form.nacionalidade}
              onChange={(e) => set('nacionalidade', e.target.value)}
              placeholder="Brasileira"
            />
          </div>
        </div>
      )}

      {/* Anotações */}
      <div className="space-y-1.5">
        <Label htmlFor="notes">Anotações</Label>
        <Textarea
          id="notes"
          value={form.notes}
          onChange={(e) => set('notes', e.target.value)}
          rows={3}
          placeholder="Anotações internas sobre o cliente..."
        />
      </div>
    </div>
  );
}
